import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ToastProvider, ConfirmProvider } from './uxComponents';
// Filet racine (lot Fiabilité 4) : journalise les erreurs de rendu et évite
// l'écran blanc. Passif tant que l'app fonctionne.
import ErrorBoundaryAramis from './ErrorBoundaryAramis';
import { initErreursFront } from './erreursFront';
import { lazyRetry } from './lazyRetry';
// Écran « Genèse » (déjà dans main.js via App) : relaie le splash statique
// d'index.html le temps de charger une page de vote.
import { BootGenese } from './AuthBackdrop';
import AppPublique from './AppPublique';
import { routePublique } from './routesPubliques';
// Tokens du Enio Design System (variables CSS --enio-*, --tint-*, --space-*,
// --radius-*, --tracking-*). Importés une seule fois ici → disponibles dans
// toute l'app, y compris les composants DS et le chunk lazy de l'assistant
// « Préparer une présentation ». Cf. src/design-system/ds-tokens.css.
import './design-system/ds-tokens.css';
// Thème Aramis — SOURCE DE VÉRITÉ UNIQUE des JETONS (Chantier 3, étendu en
// L2 « Mosaïque vivante ») : surfaces/textes/bordures/ombres des deux thèmes,
// accents losanges, échelles --fs-*/--radius-*/--elev-*, mouvement. RIEN QUE
// des jetons : les règles vont dans src/feuilleGlobale.js.
// applyTheme() ne fait plus que basculer body.theme-dark/theme-light.
import './theme.css';
// Keyframes et utilitaires partagés par TOUTES les pages (fournisseurs racine
// ToastProvider/ConfirmProvider, pages du vote qui ne montent pas App).
// Ordre complet des feuilles : en-tête de src/feuilleGlobale.js.
import './primitivesGlobales.css';

// Vote en direct de l'AG (24/09/2026) : pages publiques AUTONOMES, montées
// AVANT <App/> — ni boot Aramis (abonnements delegates, sessions/current… sur
// 150 téléphones anonymes), ni service worker (≈ 2,3 Mo de préchauffe par
// téléphone sur le wifi de la salle). /vote/<code> = téléphone,
// /vote/<code>/ecran = écran de salle ; un chemin /vote/… mal formé arrive
// sur le téléphone avec code null (« Lien introuvable »).
const ROUTE_VOTE = window.location.pathname.match(/^\/vote\/([A-Za-z0-9_-]{1,40})(\/ecran)?\/?$/);
const EST_VOTE = /^\/vote(\/|$)/.test(window.location.pathname);
const codeVote = ROUTE_VOTE ? ROUTE_VOTE[1].toLowerCase() : null;
const VoteAgPublic = lazyRetry(() => import('./VoteAgPublic'));
const VoteAgEcran = lazyRetry(() => import('./VoteAgEcran'));

// Pages publiques à JETON (présence, pouvoir, émargement, repas — 28/09/2026) :
// même principe que le vote. Un lien de convocation mettait ~15 s à s'ouvrir
// au premier passage : Aramis démarrait en entier (écouteurs Firestore,
// ~1,3 Mo, service worker) avant la page. Elles sont montées AVANT <App/> ;
// App.jsx garde leurs routes en secours (cf. src/routesPubliques.js).
const ROUTE_PUBLIQUE = EST_VOTE ? null : routePublique(window.location);

const root = ReactDOM.createRoot(document.getElementById('root'));
initErreursFront();
root.render(
  <ErrorBoundaryAramis>
    <ToastProvider>
      <ConfirmProvider>
        {EST_VOTE ? (
          <Suspense fallback={<BootGenese />}>
            {ROUTE_VOTE && ROUTE_VOTE[2] ? <VoteAgEcran code={codeVote} /> : <VoteAgPublic code={codeVote} />}
          </Suspense>
        ) : ROUTE_PUBLIQUE ? <AppPublique route={ROUTE_PUBLIQUE} /> : <App />}
      </ConfirmProvider>
    </ToastProvider>
  </ErrorBoundaryAramis>
);

// ── Service Worker registration (PWA) ────────────────────────────────────────
// En dev (npm start) : on saute l'enregistrement du SW pour éviter le cache
// agressif sur /static/js/bundle.js qui masque les édits live.
// Pages de vote et pages publiques à jeton : pas de SW (sa préchauffe
// coûterait ~2,3 Mo par téléphone, en concurrence avec la page).
const isDev = process.env.NODE_ENV === "development";
// Maquette d'Hestia (build local du CODIR, scripts/maquette-hestia.mjs) : pas
// de service worker sur localhost, il resterait après la démonstration.
const EST_MAQUETTE_HESTIA = process.env.REACT_APP_HESTIA_MAQUETTE === "1";
if ("serviceWorker" in navigator && !isDev && !EST_VOTE && !ROUTE_PUBLIQUE && !EST_MAQUETTE_HESTIA) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        console.log("[SW] Registered:", reg.scope);
        // Check for updates every 60 minutes
        setInterval(() => reg.update(), 60 * 60 * 1000);
      })
      .catch((err) => console.warn("[SW] Registration failed:", err));
  });
}
